export const SortOptions = (options = [], key = 'name') => {
  if (!Array.isArray(options)) {
    return [];
  }

  if (typeof options[0] === 'object') {
    return [...options].sort((a, b) => (a[key] || '').localeCompare(b[key] || ''));
  }

  return [...options].sort((a, b) => a.localeCompare(b));
};
